import { createContext, ReactNode, useState } from 'react';

interface AppContextType {
  season: string;
  assignSeason: (newseason?: string) => void;
}

interface AppProviderProps {
  children: ReactNode;
}
const calcSeason = () => {
  let dt: Date | string = new Date();
  const mm = dt.getMonth() + 1;
  const dd = dt.getDate();
  dt =
    (mm < 10 ? '0' + mm : mm.toString()) + (dd < 10 ? '0' + dd : dd.toString());
  if (dt > '1220' || dt < '0321') return 'winter';
  if (dt > '0320' && dt < '0621') return 'spring';
  if (dt > '0620' && dt < '0921') return 'summer';
  return 'autumn';
};

export const AppContext = createContext<AppContextType>({
  season: '',
  assignSeason: () => {},
});

export const AppProvider = ({ children }: AppProviderProps) => {
  const [season, setSeason] = useState('');

  const assignSeason = (newSeason: string | undefined) =>
    setSeason(newSeason || calcSeason());

  const value = { season, assignSeason };

  return <AppContext value={value}>{children}</AppContext>;
};
